<div class="search-wrapper">
  <input [(ngModel)]="searchTerm" type="search" placeholder="Search" />
  <div inlineSVG="/assets/icons/magnifying-glass.svg"></div>
</div>
<evrideo-recording-asset-group
  [searchTerm]="searchTerm"
  [title]="'channels'"
  [icon]="'/assets/icons/channels-icon.svg'"
  [items]="channelsSources"
  (createPreviewFromManager)="onCreatePreviewRequest($event)"
  (createRecordingJobFromManager)="
    onCreateRecordingJobFromManagerRequest($event)
  "
  (navigateToSchdulerFromManager)="
    onNavigateToSchdulerFromManagerRequest($event)
  "
></evrideo-recording-asset-group>

<evrideo-recording-asset-group
  [searchTerm]="searchTerm"
  [title]="'feeds'"
  [icon]="'/assets/icons/feeds-icon.svg'"
  [items]="feedsSources"
  (createPreviewFromManager)="onCreatePreviewRequest($event)"
  (createRecordingJobFromManager)="
    onCreateRecordingJobFromManagerRequest($event)
  "
></evrideo-recording-asset-group>
